import type { WallAuthor, WallPost, WallPostCore } from '@/types/api';

function isLegacyWallPost(post: WallPostCore | WallPost): post is WallPost {
  return 'nickname' in post && typeof post.nickname === 'string';
}

export function attachWallAuthors(
  posts: WallPostCore[] | WallPost[] | undefined,
  authors: Record<string, WallAuthor> | undefined,
): WallPost[] {
  const list = Array.isArray(posts) ? posts : [];
  const authorMap = authors ?? {};

  return list.map((post) => {
    if (isLegacyWallPost(post)) {
      return post;
    }

    const author = authorMap[String(post.userId)];
    return {
      ...post,
      reactions: post.reactions ?? [],
      nickname: author?.nickname ?? 'Гость',
      avatar: author?.avatar ?? null,
    };
  });
}

export function attachWallAuthor(post: WallPostCore, author: WallAuthor): WallPost {
  return {
    ...post,
    reactions: post.reactions ?? [],
    nickname: author.nickname,
    avatar: author.avatar,
  };
}

export function normalizeWallPostsResponse(response: {
  posts?: WallPostCore[] | WallPost[];
  authors?: Record<string, WallAuthor>;
}): WallPost[] {
  return attachWallAuthors(response.posts, response.authors);
}
